import { ReactElement } from 'react';

import axios from 'axios';
import { useEffectOnce } from 'usehooks-ts';

import {
  useBalanceMutation,
  useBoolean,
  useSelector,
  useSessionMutation
} from '../../../../common/hooks';
import Iframe from '../../../../components/Iframe';
import Image from '../../../../components/Image';
import LoginButton from '../../../../components/LoginButton';
import { handleReturnGameURL } from '../../../Games/components/LiveCasinoGames/common/utils';
import { Game } from '../../../Games/types';
import Product from '../Product';
import Modal from '../ProductModal';

const lobby: Omit<Game, 'src'> = {
  name: 'Lobby',
  method: handleReturnGameURL,
  modes: ['real'],
  urlData: {
    id: 'BJ',
    tableId: '0'
  }
};

export default function LiveCasino(): ReactElement {
  const source = axios.CancelToken.source();

  const user = useSelector((state) => state.user);

  const [modalOpen, setModalOpen] = useBoolean();
  const [loginOpen, setLoginOpen] = useBoolean();

  const sessionMutation = useSessionMutation({
    options: {
      onSuccess: () => {
        setModalOpen.on();
      },
      onError: () => {
        setLoginOpen.on();
      }
    }
  });

  const balanceMutation = useBalanceMutation({});

  const handleClose = (): void => {
    setModalOpen.off();
    balanceMutation.mutate({
      sessionKey: user.data.sessionId,
      playerId: user.data.playerId,
      email: user.data.email
    });
  };

  useEffectOnce(() => {
    return () => source.cancel();
  });

  return (
    <>
      <Product
        label='Live Casino'
        hash='livecasino_product'
        color='primary'
        image={
          <Image
            alt='Live Casino Image'
            thumbnailSrc='https://cdn.tain.com/demo/products/low-quality/livecasino.png'
            fullSrc='https://cdn.tain.com/demo/products/high-quality/livecasino.png'
          />
        }>
        <LoginButton
          open={loginOpen}
          color='primary'
          loading={user.data.loggedIn ? sessionMutation.isLoading : false}
          onClick={() => sessionMutation.mutate({ sessionKey: user.data.sessionId })}
          onSuccess={() => setModalOpen.on()}
          onSetModal={(bool) => (bool ? setLoginOpen.on() : setLoginOpen.off())}
          variant='contained'>
          Open
        </LoginButton>
      </Product>

      <Modal
        open={modalOpen}
        title='Live Casino'
        video='https://cdn.tain.com/amazing/video/AGaming_Live_final_06.mp4'
        onClose={handleClose}>
        <Iframe
          title='AG Live Casino Lobby'
          src={lobby ? lobby.method(lobby.urlData, user.data.sessionId) : ''}
        />
      </Modal>
    </>
  );
}
